(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-header.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/betslip-header.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom;
const locationNameAtom = svs.lyckoplatsen.shared_map.atoms.locationNameAtom;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const IconButton = svs.ui.ReactIconButton;
const Icon = svs.ui.ReactIcon;
const BetslipHeader = () => {
  const _useAtom = useAtom(pinLocationAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    pinLocation = _useAtom2[0],
    setPinLocation = _useAtom2[1];
  const _useAtom3 = useAtom(locationConfirmedAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    locationConfirmed = _useAtom4[0],
    setLocationConfirmed = _useAtom4[1];
  const locationName = useAtomValue(locationNameAtom);
  const _useState = useState(locationName),
    _useState2 = _slicedToArray(_useState, 2),
    displayedName = _useState2[0],
    setDisplayedName = _useState2[1];
  const _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    nameVisible = _useState4[0],
    setNameVisible = _useState4[1];
  const latRef = useRef(null);
  const lngRef = useRef(null);
  useEffect(() => {
    if (locationName === displayedName) {
      return;
    }
    setNameVisible(false);
    const t = setTimeout(() => {
      setDisplayedName(locationName);
      setNameVisible(true);
    }, 250);
    return () => clearTimeout(t);
  }, [displayedName, locationName]);
  useEffect(() => {
    var _latRef$current, _lngRef$current;
    if (!pinLocation.lat || !pinLocation.lng) {
      return;
    }
    const latObj = {
      value: parseFloat((_latRef$current = latRef.current) === null || _latRef$current === void 0 ? void 0 : _latRef$current.textContent) || 0
    };
    const lngObj = {
      value: parseFloat((_lngRef$current = lngRef.current) === null || _lngRef$current === void 0 ? void 0 : _lngRef$current.textContent) || 0
    };
    gsap.to(latObj, {
      value: pinLocation.lat,
      duration: 0.35,
      onUpdate: () => {
        if (latRef.current) {
          latRef.current.textContent = latObj.value.toFixed(6);
        }
      }
    });
    gsap.to(lngObj, {
      value: pinLocation.lng,
      duration: 0.35,
      onUpdate: () => {
        if (lngRef.current) {
          lngRef.current.textContent = lngObj.value.toFixed(6);
        }
      }
    });
  }, [pinLocation.lat, pinLocation.lng]);
  const handleIconClick = () => {
    setPinLocation({
      lat: null,
      lng: null
    });
    setLocationConfirmed(false);
    setTimeout(() => {
      setDisplayedName('');
    }, 300);
  };
  return React.createElement("div", {
    className: "lp-betslip-header f-content"
  }, !locationConfirmed && React.createElement(IconButton, {
    className: "betslip-close",
    onClick: () => handleIconClick(),
    title: "St\xE4ng ikon"
  }, React.createElement(Icon, {
    icon: "close"
  })), React.createElement("h3", {
    className: "name",
    style: {
      opacity: nameVisible ? 1 : 0
    }
  }, displayedName), React.createElement("p", {
    className: "coords"
  }, React.createElement("span", {
    ref: latRef
  }, typeof pinLocation.lat === 'number' ? pinLocation.lat.toFixed(6) : '00.000000'), "\xB0N,\xA0", React.createElement("span", {
    ref: lngRef
  }, typeof pinLocation.lng === 'number' ? pinLocation.lng.toFixed(6) : '00.000000'), "\xB0E"));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  BetslipHeader
});

 })(window);